import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { getInitialDishName } from "../constants";

interface ModalCloneMenuItemFormEffectsProps {
    pickedCategoryIds?: number[];
    menuItemName?: string;
}

interface FormValues {
    name: string;
    categories: number[];
}

const ModalCloneMenuItemFormEffects: React.FC<ModalCloneMenuItemFormEffectsProps> = ({
    pickedCategoryIds,
    menuItemName,
}) => {
    const { t } = useTranslation();
    const { setFieldValue } = useFormikContext<FormValues>();

    useEffect(() => {
        if (pickedCategoryIds) {
            setFieldValue("categories", pickedCategoryIds, false);
        }
    }, [pickedCategoryIds, setFieldValue]);

    useEffect(() => {
        const initialNameWithLimit = getInitialDishName(menuItemName, t);

        if (initialNameWithLimit) {
            setFieldValue("name", initialNameWithLimit, false);
        }
    }, [menuItemName, t, setFieldValue]);

    return null;
};

export default ModalCloneMenuItemFormEffects;
